module.exports = __webpack_public_path__ + "img/coding.320640d5.gif";